import { otaUpdatesUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";

export const getAbortInstall = async (
  namespace: string,
  update_id: string,
  source_id: string,
) => {
  const url = otaUpdatesUrlEnvVar();

  const headers = {
    ...buildAxiosAuthenticationHeaders(),
  };

  try {
    const response = await axios.get(
      `${url}/api/v1/ns/${namespace}/installation/abort`,
      {
        params: {
          update_id,
          source_id,
        },
        headers,
      },
    );

    return response.data;
  } catch (err) {
    if (isAxiosError(err)) {
      const message =
        err.response?.data?.detail ||
        err.response?.data?.title ||
        "Failed to abort firmware installation. Please try again.";

      throw new Error(message);
    } else {
      throw new Error(
        "An unexpected error occurred while aborting firmware installation.",
      );
    }
  }
};
